<script lang="ts">
    import { onDestroy, onMount } from 'svelte'
    import { fade } from 'svelte/transition'

    export let show: boolean
    let goShow: boolean = false
    export let delay: number = 1000

    onMount(() => {
        show = false
    })

    onDestroy(() => {
        document.querySelector('body').style.pointerEvents = 'unset'
    })

    $: {
        if (show) {
            setTimeout(() => {
                if (show) {
                    goShow = true
                }
            }, delay)
        } else {
            goShow = false
            document.querySelector('body').style.pointerEvents = 'unset'
        }
    }
    $: if (goShow) {
        document.querySelector('body').style.pointerEvents = 'none'
    } else {
        document.querySelector('body').style.pointerEvents = 'unset'
    }
</script>

{#if goShow}
    <div class="loadspiner" in:fade|global={{ duration: 100 }} out:fade|global={{ duration: 100 }} style="pointer-events:none">
        <div class="spinner" />
        <div class="spinner_content">
            <slot></slot>
        </div>
    </div>
{/if}

<style>
    .loadspiner {
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        position: absolute;
        z-index: 9997;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        min-height: 400px;
        width: 100%;
        background: #00000090;
        pointer-events: none;
        color: #eee;
        border: 0px solid red;
        flex-direction: column;
    }

    .spinner_content {
        white-space: pre-line;
    }

    .loadspiner:hover {
        pointer-events: none;
    }

    @keyframes spinner {
        to {
            transform: rotate(360deg);
        }
    }

    .spinner:before {
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 30%;
        left: 50%;
        width: 40px;
        height: 40px;
        margin-top: -20px;
        margin-left: -20px;
        border-radius: 50%;
        border: 5px solid #fff;
        border-top-color: #1565c0;
        animation: spinner 0.6s linear infinite;
    }
</style>
